import { render, staticRenderFns } from "./InventoryHistory.vue?vue&type=template&id=95857022"
import script from "./InventoryHistory.vue?vue&type=script&lang=js"
export * from "./InventoryHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports